import { createFileRoute } from '@tanstack/react-router'
import { HtmlEditorInfo } from '../components/HtmlEditorInfo'
import { INITIAL_EDITOR_CONTENT } from '../components/InitialEditorContent'
import { LazyDualEditorPanel } from '../components/LazyDualEditorPanel'
import { HOME_PAGE_TITLE, SITE_DESCRIPTION, pageHead } from '../lib/seo'

export const Route = createFileRoute('/')({
  head: () =>
    pageHead({
      path: '/',
      rawTitle: HOME_PAGE_TITLE,
      description: SITE_DESCRIPTION
    }),
  component: App
})

function App() {
  return (
    <div className="w-full pb-12">
      <LazyDualEditorPanel initialContent={INITIAL_EDITOR_CONTENT} />
      <HtmlEditorInfo />
    </div>
  )
}
